import * as React from 'react';
import { Button } from '@mui/material';
import { useStyles } from '../../modalEditProfile.styles';
import { IProps } from '../../types';

export const UploadButtons = (props: IProps):JSX.Element => {
  const {
    setImage,
    inputRef,
    handleUpload,
    croppedImage,
    setCroppedImage,
    setUploadVisible,
    changeImageHandler,
  } = props;
  const classes = useStyles();

  const openEditModal = () => {
    setImage(croppedImage);
    setUploadVisible(true);
  };

  const onDelete = () => {
    setCroppedImage('');
  };

  return (
    <div className={classes.uploadBlock}>
      {
        !!croppedImage
          ? <div className={classes.imgActions}>
            <Button
              variant="contained"
              className={classes.uploadBtn}
              onClick={openEditModal}
            >Edit photo
            </Button>
            <Button
              variant="contained"
              className={classes.cancelBtn}
              onClick={onDelete}
            >Delete
            </Button>
          </div>
          : <div>
            <input
              ref={inputRef}
              id="input"
              className={classes.inputStyle}
              type="file"
              accept=".png,.jpeg,.jpg"
              onChange={(e): void => changeImageHandler(e)}
            />
            <Button
              variant="contained"
              className={classes.uploadBtn}
              onClick={handleUpload}
            >Upload
            </Button>
          </div>
      }
      <div className={classes.uploadText}>
        Upload file PNG or JPG.
      </div>
    </div>
  );
};
